import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./description.scss";
import {DivCollapser2} from "../../../../../../../common/design2/div-collapser-2/div-collapser-2";

export const Description = ({text, xdQaName=undefined}) => cs(
    ["divCollapser", (_, next) => DivCollapser2({
        collapsedHeight: 47,
        next,
    })],
    ({divCollapser}) => (
        <div className="description description-1no">
            {divCollapser.render({
                className: "text",

                renderContent: (ref) => (
                    <div className="text-inner-49r" ref={ref} xd-qa-type="label" xd-qa-name={xdQaName+" Description"}>
                        {text}
                    </div>
                ),
            })}

            {!divCollapser.pointless && (
                <div
                    className="toggle"
                    onClick={divCollapser.toggle}
                    xd-qa-type="link"
                    xd-qa-name={xdQaName+" Description Toggle"}
                >
                    {(divCollapser.collapsed || divCollapser.collapsing) ? (
                        "+ More"
                    ) : (
                        "- Less"
                    )}
                </div>
            )}
        </div>
    )
);